import { keys, reduce, isNil, isEmpty } from 'lodash';
import { Helpers, Validations } from '@utils/helpers';
import { CoverageForm } from '@models/DPI/Coverage.model';
import { IError } from '@utils/useForm';

export const validate = (values: CoverageForm) => {
  const fields = keys(values);
  const errors: any = reduce(fields, (result, field: string) => {
    return { ...result, [field]: validateField(values, field) };
  }, {});
  return errors;
}

export const validateField = (values: any, name: string) => {
  const value = values[name];
  let error: IError | undefined = { isValid: true };
  switch (name) {
    case 'sumAssured':
      if (isNil(value)) {
        error = { isValid: false };
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: `This field cannot be empty` };
        } else {
          const minPlanAssured = 50000, maxPlanAssured = 400000, dividendSumAssured = 1000;
          const planSumAssured = Number(value);
          const isOutOfAssured = Validations.isInRange(planSumAssured, minPlanAssured, maxPlanAssured);
          if (isOutOfAssured !== 0) {
            error = { isValid: false, message: `Please enter Sum Assured from ${Helpers.toCurrencyND(minPlanAssured)} to ${Helpers.toCurrencyND(maxPlanAssured)}` }
          } else {
            if (!Validations.isDivisible(planSumAssured, dividendSumAssured)) {
              error = { isValid: false, message: `Please enter Sum Assured  in multiples of S$${dividendSumAssured}` }
            }
          }
        }
      }

      break;
    case 'policyTerm':
    case 'planPremiumMode':
      if (isNil(value)) {
        error = { isValid: false };
      }
      break;
    case 'illnessCover':
      if (!isEmpty(value)) {
        if (value !== values['sumAssured']) {
          error = { isValid: false, message: `Please enter the same amount as Basic Plan’s Sum Assured`}
        }
      }
      break;
    default:
      break;
  }
  return error;
}